import { combineReducers } from 'redux';
import * as types from '../actions/ActionTypes.js';

const matSupportFilter = (state = {}, action) => {
    switch (action.type) {
        case types.SET_MAT_SUPPORT_FILTER:
            return action.filter;
        default:
            return state;
    }
};

export const getMatSupportFilter = (state) => state.matSupportPage.matSupportFilter;

const matSupportExpandedDevice = (state = {}, action) => {
    switch (action.type) {
        case types.SET_MAT_SUPPORT_EXPANDED_DEVICE:
            return action.expandedDevice;
        default:
            return state;
    }
};

export const getMatSupportExpandedDevice = (state) => state.matSupportPage.matSupportExpandedDevice;

const matSupportReportFilter = (state = 'steps', action) => {
    switch (action.type) {
        case types.SET_MAT_SUPPORT_REPORT_FILTER:
            return action.filter;
        default:
            return state;
    }
};

export const getMatSupportReportFilter = (state) => state.matSupportPage.matSupportReportFilter;

const matSupportPage = combineReducers({
    matSupportFilter,
    matSupportExpandedDevice,
    matSupportReportFilter
});

export default matSupportPage;
